export enum StaticMessages {
  CONNECTION_ERROR_GENERIC = "There was an error connecting to the application. Please try again later.",
  REGISTRATION_SUCCESSFUL = "Account creation completed. Please check the email address associated with this account to activate it.",
  LOGIN_SUCCESS = "You are now logged in.",
  LOGOUT = "You are now logged out",
  FORGOT_PASSWORD_LINK = "Please check the associated email address for your password reset link.",
  NEW_ADDRESS_SUCCESS = "A new address has been added.",
  NEW_CONTACT_SUCCESS = "A new contact has been added.",
  PASSWORD_RESET_SUCCESS = "Your password was reset successfully.",
  ACTIVATION_LINK_RESENT = "Your activation link has been resent. Please check the email address associated with this account.",
  ACCOUNT_ACTIVATION_SUCCESS = "Your account has been successfully activated.",
  BANK_ACCOUNT_ADDED_SUCCESS = "A new bank account has been added successfully.",
  LOCAL_OFFICE_CHANGED_SUCCESS = "Local office changed successfully.",
  PASSWORD_CHANGED_SUCCESS = "Your password has been changed successfully.",
  EMAIL_CHANGE_REQUESTED = "An email change has been requested. Please check the email entered to verify this change.",
  EMAIL_CHANGED_SUCCESS = "Your email has been changed successfully.",
  CONTACT_SET_AS_PRIMRAY = "Your primary contact has been changed successfully.",
}
